import { FunctionComponent } from 'react';

import LayoutContainer from 'components/layout/LayoutContainer';

import { Props } from './index';
import StyledComponent from './styles';

const PublicLayoutSectionHeroCompany: FunctionComponent<Props> = ({ background, underline, layoutContainerProps, headline, subheadline, infoHeadline, children }) => {
    return (
        <StyledComponent
            className='public-layout-section-hero-company'
            style={{ backgroundImage: `url(${background.desktop[0].href})` }}
        >
            <LayoutContainer {...layoutContainerProps}>
                <h1 className="copy">
                    {headline && (
                        <div className="headline-wrapper">
                            <div
                                className="headline"
                                dangerouslySetInnerHTML={{ __html: headline }}
                                style={{
                                    backgroundImage: `url(${underline})`,
                                }}
                            />
                        </div>
                    )}
                    {subheadline && (
                        <div className="headline-wrapper">
                            <div
                                className="subheadline"
                                dangerouslySetInnerHTML={{ __html: subheadline }}
                                style={{
                                    backgroundImage: `url(${underline})`,
                                }}
                            />
                        </div>
                    )}
                </h1>
            </LayoutContainer>
            {infoHeadline && (
                <div className="info-headline-wrappper">
                    <div
                        className="infoheadline"
                        dangerouslySetInnerHTML={{ __html: infoHeadline }}
                    />
                </div>
            )}
            {children && children}
        </StyledComponent>
    );
};

export default PublicLayoutSectionHeroCompany;